(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nd-inline-review-carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nd-mini-reviews]').forEach(function(carousel){
  if(carousel.dataset.ready==='true')return;
  carousel.dataset.ready='true';
  var track=carousel.querySelector('[data-nd-mini-track]');
  var slides=Array.from(track.children);
  var dots=Array.from(carousel.querySelectorAll('[data-nd-mini-dot]'));
  var index=0;
  var timer;
  var paused=false;
  var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function updateDots(){
    dots.forEach(function(dot,dotIndex){
      if(dotIndex===index)dot.setAttribute('aria-current','true');
      else dot.removeAttribute('aria-current');
    });
  }

  function goTo(nextIndex,behavior){
    index=(nextIndex+slides.length)%slides.length;
    track.scrollTo({left:slides[index].offsetLeft,behavior:behavior||'smooth'});
    updateDots();
  }

  function start(){
    window.clearInterval(timer);
    if(paused||reduceMotion)return;
    timer=window.setInterval(function(){goTo(index+1,'smooth')},Number(carousel.dataset.delay)||3000);
  }

  function pause(){paused=true;window.clearInterval(timer)}
  function resume(){paused=false;start()}

  dots.forEach(function(dot,dotIndex){
    dot.addEventListener('click',function(){goTo(dotIndex,'smooth');start()});
  });

  var scrollTimer;
  track.addEventListener('scroll',function(){
    window.clearTimeout(scrollTimer);
    scrollTimer=window.setTimeout(function(){
      var closest=0;
      var distance=Infinity;
      slides.forEach(function(slide,slideIndex){
        var currentDistance=Math.abs(track.scrollLeft-slide.offsetLeft);
        if(currentDistance<distance){distance=currentDistance;closest=slideIndex}
      });
      index=closest;
      updateDots();
    },80);
  },{passive:true});

  carousel.addEventListener('mouseenter',pause);
  carousel.addEventListener('mouseleave',resume);
  carousel.addEventListener('focusin',pause);
  carousel.addEventListener('focusout',resume);
  track.addEventListener('pointerdown',function(){window.clearInterval(timer)},{passive:true});
  track.addEventListener('pointerup',start,{passive:true});
  track.addEventListener('pointercancel',start,{passive:true});
  updateDots();
  start();
});
  } catch(e) { console.error(e); }
})();

})();
